import { SCENES_MAP } from 'consts';

export const GOOGLE_API_KEY = 'AIzaSyCFbUVen9m3vpnJUvXb6NhKyOcEZE5AB3Y';
export const RECORDING_TIMEOUT = 10000; // 10 seconds
export const LANGUAGE_CODE = 'vi-VN'; // Vietnamese
export const SAMPLE_RATE = 48000;
export const CHATBOT_API_URL =
  'https://vizion-chatbot-api.success-ss.com.vn:5443/v1';
export const CHATBOT_TOKEN = 'app-CrZplWbHuCJ1vQnyWiKXjDOt';
// Empty = same-origin `/api/*` (CRA setupProxy in dev, CloudFront in prod).
// Avoids mixed-content blocks when the tour is served over HTTPS.
export const CHAT_API_URL = process.env.REACT_APP_CHAT_API_URL || '';
export const CHAT_API_KEY =
  process.env.REACT_APP_CHAT_API_KEY ||
  'dc_hb0JcacvqWM_Rq8rLbwsI-LRumY68lqVs0lVRI7s';
export const CHATBOT_NAME = 'Aurora_Residence_Chatbot';

// OpenAI TTS Configuration
export const OPENAI_TTS_CONFIG = {
  model: 'tts-1', // or 'tts-1-hd' for higher quality
  voice: 'nova', // options: alloy, echo, fable, onyx, nova, shimmer
  response_format: 'mp3',
};

export const AUDIO_CONSTRAINTS = {
  echoCancellation: true,
  noiseSuppression: true,
  sampleRate: SAMPLE_RATE,
};

export const CHATBOT_MAP = {
  ...SCENES_MAP,
  ...{
    1: {
      url: '/lien-ket-vung',
    },
    2: {
      url: '/so-do-tong-the',
    },
    3: {
      url: '/mat-bang-tang',
    },
    4: {
      url: '/so-do-tien-ich',
    },
    5: {
      url: '/thu-vien',
    },
  },
};

export const MIME_TYPES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/ogg;codecs=opus',
  'audio/aac',
];
